const initialState = {
  agencies: [],
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case "SET_AGENCIES":
      return {
        ...state,
        agencies: action.payload,
      };
    default:
      return state;
  }
};
